import React, { Component } from 'react';
import { connect } from 'react-redux';

const allActionCreators = Object.assign({});

export class FlatButton extends Component {

  handleClick(evt) {

    if(evt) { evt.preventDefault(); }
    
    if(this.props.onClick) {
      this.props.onClick();
    }
  }

  getStyle() {
    const styleObj = this.props.style || {};
    const labelStyleObj = this.props.labelStyle || {};

    return Object.assign({}, styleObj, labelStyleObj);
  }

  render() {
    return <button 
            className={`FlatButton ${this.props.className || ''}`} 
            type='button' 
            onClick={this.handleClick.bind(this)}
            style={this.getStyle()}
            disabled={this.props.disabled}>
      {this.props.label || ''}
    </button>;
  }
}

function mapStateToProps(state) {
  return {

  };
}
export default FlatButton;


export const FlatButtonContainer = connect(
  mapStateToProps,
  allActionCreators
)(FlatButton);